export const profile = {
  'profile.businessTitle': 'Profil d\'Entreprise',
  'profile.businessSubtitle': 'Informations et métriques essentielles de l\'entreprise',
  'profile.clientProfileTitle': 'Profil Client',
  'profile.clientProfileSubtitle': 'Détails et informations de contact du client',
  'profile.assistantTitle': 'Assistant d\'Entreprise',
  'profile.assistantDesc': 'Obtenez des recommandations personnalisées',
  'profile.assistantPlaceholder': 'Demandez-moi des pratiques commerciales, opportunités de financement, exigences de conformité...',
  'profile.assistantResponse': 'Basé sur votre profil d\'entreprise, je suggère d\'explorer les programmes d\'investissement durable. Il existe plusieurs subventions disponibles pour ce type de mise à niveau qui pourraient couvrir jusqu\'à 60% des coûts. Souhaitez-vous plus d\'informations?',
  'profile.documentTitle': 'Documents',
  'profile.documentSubtitle': 'Voir et gérer les documents d\'entreprise',
  'profile.regulatoryOverview': 'Aperçu Réglementaire',
  'profile.complianceStatus': 'Statut de Conformité',
  'profile.sustainabilityScore': 'Score de Durabilité',
  'profile.certificationEligibility': 'Éligibilité à la Certification',
  'profile.aiUpdates': 'Mises à jour IA',
  'profile.aiUpdateInitial': 'Comment puis-je améliorer le score de durabilité de mon entreprise?',
  'profile.aiUpdateResponse': 'Basé sur vos métriques actuelles, se concentrer sur l\'efficacité opérationnelle et les pratiques durables aurait le plus grand impact sur votre score de durabilité.',
  'profile.regionOpportunityScore': 'Score d\'Opportunité Régionale',
  'profile.fundingDensity': 'Densité de Financement',
  'profile.policyFriendliness': 'Convivialité Politique',
  'profile.recentApprovals': 'Approbations Récentes',
  'profile.high': 'Élevé',
  'profile.medium': 'Moyen',
  'profile.veryHigh': 'Très Élevé',
  'profile.low': 'Bas',
  'profile.attachedSubsidies': 'Subventions Attachées',
  'profile.manuallyAttached': 'Attachées Manuellement',
  'profile.automaticallyMatched': 'Correspondues Automatiquement',
  'profile.noDocuments': 'Aucun document téléchargé',
  'profile.readyForPrefill': 'Prêt pour l\'extraction automatique',
  'profile.uploadDocument': 'Télécharger un Document',
  'profile.documents': 'Documents',
  'profile.documentsUploaded': 'documents téléchargés',
  'profile.extractedInformation': 'Informations Extraites',

  // Profile Overview Enhanced
  'profile.editProfile': 'Modifier le Profil',
  'profile.seeSubsidies': 'Voir les Subventions',
  'profile.smartOverview': 'Aperçu Intelligent',
  'profile.fullProfile': 'Profil Complet',

  // Company Identity Cockpit
  'profile.companyIdentity': 'Identité de l\'Entreprise',
  'profile.legalName': 'Raison Sociale',
  'profile.legalForm': 'Forme Juridique',
  'profile.employees': 'Employés',
  'profile.siren': 'SIREN',
  'profile.sectorActivity': 'Secteur et Activité',
  'profile.nafCode': 'Code NAF',
  'profile.activityDescription': 'Description de l\'Activité',
  'profile.leadership': 'Direction',
  'profile.aiExtractedIntelligence': 'Intelligence Commerciale Extraite par IA',
  'profile.businessActivities': 'Activités Commerciales',
  'profile.innovationTechnology': 'Innovation & Technologie',
  'profile.sustainabilityFocus': 'Focus Durabilité',
  'profile.exportMarkets': 'Marchés d\'Exportation',
  'profile.aiDiscovered': '✨ Découvert par IA à partir du site web',
  'profile.automaticallyDiscovered': 'Découvert automatiquement à partir du site web de votre entreprise',
  'profile.moreDirectors': 'directeurs supplémentaires',

  // Company Details (Extended)
  'profile.noCompanyData': 'Aucune donnée d\'entreprise disponible. Veuillez compléter votre profil.',
  'profile.selectedSectors': 'Secteurs Sélectionnés',
  'profile.director': 'Directeur',
  'profile.geographicPresence': 'Présence Géographique',
  'profile.headquarters': 'Siège',
  'profile.site': 'Site',
  'profile.moreLocations': 'emplacements supplémentaires',
  'profile.sizeCategory': 'Taille et Catégorie',
  'profile.companyCategory': 'Catégorie d\'Entreprise',
  'profile.employeeCount': 'Nombre d\'Employés',
  'profile.employeesText': 'employés',
  'profile.companyAge': 'Âge de l\'Entreprise',
  'profile.yearsOld': 'ans',
  'profile.founded': 'Fondée en',
  'profile.establishments': 'Établissements',
  'profile.locationsText': 'emplacement(s)',
  'profile.geographicLocation': 'Localisation Géographique',
  'profile.headquartersAddress': 'Adresse du Siège',
  'profile.region': 'Région',
  'profile.codeLabel': 'Code :',
  'profile.department': 'Département',
  'profile.gpsCoordinates': 'Coordonnées GPS',
  'profile.certifications': 'Certifications',
  'profile.certificationsInfo': 'Ces certifications peuvent débloquer des opportunités de subventions supplémentaires',
  'profile.financialData': 'Données Financières',
  'profile.fiscalYear': 'Exercice Fiscal',
  'profile.revenue': 'Chiffre d\'Affaires (CA)',
  'profile.netProfit': 'Résultat Net',
  'profile.dataEnrichmentInfo': 'Informations d\'Enrichissement',
  'profile.source': 'Source :',
  'profile.dataCompleteness': 'Complétude des Données :',
  'profile.lastUpdated': 'Dernière Mise à Jour :',
  'profile.subsidyMatchInfo': 'Ces informations nous aident à trouver de meilleures correspondances de subventions pour votre entreprise',

  // Key Info Categories
  'profile.category.funding': 'Informations de Financement',
  'profile.category.geographic': 'Portée Géographique',
  'profile.category.sector': 'Secteurs et Industries',
  'profile.category.demographics': 'Démographie Cible',
  'profile.category.timeline': 'Timing et Échéances',

  // Profile Form Field Placeholders
  'profile.placeholders.enterProfileName': 'Entrez le nom du profil',
  'profile.placeholders.enterDescription': 'Entrez la description',
  'profile.placeholders.enterFullAddress': 'Entrez l\'adresse complète',
  'profile.placeholders.enterPhoneNumber': 'Entrez le numéro de téléphone',
  'profile.placeholders.enterEmail': 'Entrez l\'adresse e-mail',
  'profile.placeholders.enterBusinessRegistration': 'Entrez le numéro d\'immatriculation',
  'profile.placeholders.enterIndustry': 'Entrez le secteur d\'activité',
  'profile.placeholders.enterEmployees': 'ex: 25-50',
  'profile.placeholders.enterRevenue': 'ex: €2-5M',
  'profile.placeholders.searchCompany': 'Nom d\'entreprise, SIRET ou SIREN',
  'profile.placeholders.enterCompanyWebsite': 'https://votreentreprise.fr',

  // Applicant Types
  'profile.applicantType.business': 'Entreprise',
  'profile.applicantType.individual': 'Particulier',

  // Edit Modals - Company Identity
  'profile.modal.editCompanyIdentity': 'Modifier l\'Identité de l\'Entreprise',
  'profile.modal.editCompanyIdentityDesc': 'Mettez à jour les informations de base de votre entreprise',
  'profile.modal.legalName': 'Raison Sociale',
  'profile.modal.legalForm': 'Forme Juridique',
  'profile.modal.siren': 'SIREN',
  'profile.modal.siret': 'SIRET',

  // Edit Modals - Company Size
  'profile.modal.editCompanySize': 'Modifier Taille et Catégorie',
  'profile.modal.editCompanySizeDesc': 'Mettez à jour le nombre d\'employés de votre entreprise',
  'profile.modal.numberOfEmployees': 'Nombre d\'Employés',

  // Edit Modals - Sector & Activity
  'profile.modal.editSectorActivity': 'Modifier Secteur et Activité',
  'profile.modal.editSectorActivityDesc': 'Mettez à jour les informations de secteur et d\'activité de votre entreprise',
  'profile.modal.nafCode': 'Code NAF',
  'profile.modal.businessSectors': 'Secteurs d\'Activité',
  'profile.modal.businessSectorsHelp': 'ex : Innovation, Technologie, Agriculture, Tourisme',

  // Edit Modals - Leadership
  'profile.modal.editLeadership': 'Modifier la Direction',
  'profile.modal.editLeadershipDesc': 'Gérez l\'équipe de direction de votre entreprise',
  'profile.modal.director': 'Directeur',
  'profile.modal.firstName': 'Prénom(s)',
  'profile.modal.lastName': 'Nom',
  'profile.modal.position': 'Fonction',
  'profile.modal.nationality': 'Nationalité',
  'profile.modal.addDirector': 'Ajouter un Directeur',

  // Edit Modals - Geographic Presence
  'profile.modal.editGeographicPresence': 'Modifier la Présence Géographique',
  'profile.modal.editGeographicPresenceDesc': 'Gérez les emplacements et établissements de votre entreprise',
  'profile.modal.headquarters': 'Siège Social',
  'profile.modal.location': 'Emplacement',
  'profile.modal.city': 'Ville',
  'profile.modal.postalCode': 'Code Postal',
  'profile.modal.address': 'Adresse',
  'profile.modal.addLocation': 'Ajouter un Emplacement',

  // Edit Modals - AI Business Intelligence
  'profile.modal.editAIBusinessIntelligence': 'Modifier l\'Intelligence Commerciale IA',
  'profile.modal.editAIBusinessIntelligenceDesc': 'Mettez à jour les données d\'intelligence commerciale de votre entreprise',
  'profile.modal.businessActivitiesLabel': 'Activités Commerciales',
  'profile.modal.businessActivitiesHelp': 'Une activité par ligne',
  'profile.modal.innovationTechnology': 'Innovation & Technologie',
  'profile.modal.innovationTechnologyHelp': 'ex : programmes R&D, brevets, transformation numérique',
  'profile.modal.sustainabilityFocus': 'Focus Durabilité',
  'profile.modal.sustainabilityFocusHelp': 'ex : objectifs neutralité carbone, énergies renouvelables, économie circulaire',
  'profile.modal.exportMarkets': 'Marchés d\'Exportation',
  'profile.modal.exportMarketsHelp': 'ex : Europe, Amérique du Nord, Asie-Pacifique',

  // Edit Modals - Common Buttons
  'profile.modal.cancel': 'Annuler',
  'profile.modal.saving': 'Enregistrement...',
  'profile.modal.saveChanges': 'Enregistrer les Modifications',

  // Employee Count Options
  'profile.employees.0': '0 employé',
  'profile.employees.1': '1 employé',
  'profile.employees.2-5': '2-5 employés',
  'profile.employees.6-10': '6-10 employés',
  'profile.employees.11-20': '11-20 employés',
  'profile.employees.21-50': '21-50 employés',
  'profile.employees.51-100': '51-100 employés',
  'profile.employees.101-250': '101-250 employés',
  'profile.employees.250+': '250+ employés',

  // Profile Edit Page
  'profile.edit.backToProfile': 'Retour au Profil',
  'profile.edit.editProfile': 'Modifier le Profil',
  'profile.edit.updateProfileInfo': 'Mettez à jour les informations de votre profil',
  'profile.edit.profileInformation': 'Informations du Profil',
  'profile.edit.deleteProfile': 'Supprimer le Profil',
  'profile.edit.suspendProfile': 'Suspendre le Profil',
  'profile.edit.cancel': 'Annuler',
  'profile.edit.saveChanges': 'Enregistrer les Modifications',

  // Delete Confirmation
  'profile.delete.title': 'Supprimer le Profil',
  'profile.delete.warning': 'Cette action est irréversible. Cela supprimera définitivement votre profil.',
  'profile.delete.confirmQuestion': 'Êtes-vous sûr de vouloir supprimer le profil "{name}" ?',
  'profile.delete.deleting': 'Suppression...',
  'profile.delete.deleted': 'Profil supprimé',
  'profile.delete.success': 'a été supprimé avec succès',
  'profile.delete.error': 'Échec de la suppression du profil. Veuillez réessayer.',

  // Suspend Confirmation
  'profile.suspend.title': 'Suspendre le Profil',
  'profile.suspend.warning': 'Ce profil sera masqué de votre tableau de bord. Vous pourrez le restaurer depuis Paramètres > Vos profils suspendu.',
  'profile.suspend.confirmQuestion': 'Êtes-vous sûr de vouloir suspendre "{name}" ?',
  'profile.suspend.suspending': 'Suspension...',
  'profile.suspend.suspended': 'Suspendu',
  'profile.suspend.restore': 'Restaurer',
  'profile.suspend.deletePermantly': 'Supprimer Définitivement',
  'profile.suspend.error': 'Échec de la suspension du profil. Veuillez réessayer.',

  // Reactivate Profile
  'profile.reactivate.success': 'Profil réactivé',
  'profile.reactivate.description': 'a été réactivé avec succès et est de nouveau visible dans votre tableau de bord',
  'profile.reactivate.error': 'Échec de la réactivation du profil. Veuillez réessayer.',

  // Company Search Section
  'profile.edit.companyInformation': 'Informations de l\'Entreprise',
  'profile.edit.useCompanySearch': 'Rechercher une Entreprise',
  'profile.edit.enterManually': 'Saisir Manuellement',
  'profile.edit.updateCompanyInfo': 'Mettre à Jour les Informations de l\'Entreprise',

  // Website Intelligence
  'profile.edit.websiteIntelligence': 'Intelligence du site web (Optionnel)',
  'profile.edit.websiteIntelligenceDesc': 'Ajoutez le site web de votre entreprise pour obtenir une analyse IA afin d\'améliorer la correspondance des subventions.',
  'profile.edit.companyWebsite': 'Site web de l\'entreprise',
  'profile.edit.allowAIAnalysis': 'Autoriser l\'analyse IA du site web',
  'profile.edit.allowAIAnalysisDesc': 'Nous analyserons le contenu public de votre site web pour identifier les capacités d\'innovation, de durabilité et d\'exportation afin d\'améliorer la correspondance des subventions.',
  'profile.edit.learnMore': 'En savoir plus',
  'profile.edit.analyzingWebsite': 'Analyse du site web...',
  'profile.edit.analyzeWebsite': 'Analyser le site web avec l\'IA',
  'profile.edit.websiteAnalyzedSuccess': '✓ Site web analysé avec succès',
  'profile.edit.aiGeneratedDescription': 'Description Générée par l\'IA :',
  'profile.edit.useDescription': 'Utiliser cette description →',
  'profile.edit.businessActivitiesIdentified': 'activités commerciales identifiées',
  'profile.edit.dataAnalyzedForMatching': 'Données analysées pour améliorer les correspondances de subventions',

  // Form Fields
  'profile.edit.profileName': 'Nom du Profil',
  'profile.edit.description': 'Description',
  'profile.edit.address': 'Adresse',
  'profile.edit.phone': 'Téléphone',
  'profile.edit.email': 'Email',
  'profile.edit.businessRegistration': 'Numéro d\'Immatriculation',
  'profile.edit.industry': 'Secteur d\'Activité',
  'profile.edit.numberOfEmployeesField': 'Nombre d\'Employés',
  'profile.edit.annualRevenue': 'Chiffre d\'Affaires Annuel',

} as const;